import React, { useState } from "react";
import TextInput from "../../../components/TextInput";
import { toast } from "../../../components/toastNotification";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import useAddBusinessOperation from "./hooks/useAddBusinessOperation";
import useBusinessOperation from "./hooks/useBusinessOperation";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../components/tables/MaterialExTable";

import { accountAtom } from "../../Login/atoms/AccountAtom";
import {
  addStateBusinessOperation,
  setFilterTextBusinessOperation,
} from "./atoms/atoms";
import SaveButton from "../../../components/SaveButton";
import CancelButton from "../../../components/CancelButton";
import { useQueryClient } from "react-query";

const BusinessOperationForm = () => {
  //Hooks
  const { mutateAsync: AddBusinessOperation } = useAddBusinessOperation();
  const { data } = useBusinessOperation();
  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(
    addStateBusinessOperation
  );
  const [filterText, setFilterText] = useRecoilState(
    setFilterTextBusinessOperation
  );
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasBusinessOperation, setHasBusinessOperation] = useState(false);
  const userAccount = useRecoilState(accountAtom);
  const queryClient = useQueryClient();

  const defaulValues = {
    businessOperationId: 0,
    businessOperationName: "",
  };
  const [emptypeNewData, setNewData] = useState([defaulValues]);
  const [businessOperationExist, setbusinessOperationExist] = useState(false);

  const handleAddBusinessOperation = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setbusinessOperationExist(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "addBusinessOperation") {
      if (fieldName === "businessOperationName") {
        const result = data.filter(
          (item) =>
            item.businessOperationName.toUpperCase() == inputvalue.toUpperCase()
        )[0];
        emptypeNewData.map((x) => (x.businessOperationName = inputvalue));
        inputvalue === ""
          ? setHasBusinessOperation(false)
          : setHasBusinessOperation(true);
      }
    }
  };

  //save changes
  const handleSave = (emptypeNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddBusinessOperation(emptypeNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setNewData([defaulValues]);
            queryClient.invalidateQueries(["GetBusinessOperation"]);
            toast.fire(
              "Success",
              "Business Operation Added Successfully",
              "success"
            );
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add Business Operation", "error");
          queryClient.invalidateQueries(["GetBusinessOperation"]);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Business Operation Name",
      field: "businessOperationName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <div className="">
              <TextInput
                defaultValue={rowData.businessOperationName}
                onChange={(e) =>
                  handleAddBusinessOperation(
                    "addBusinessOperation",
                    "businessOperationName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-downs">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Business Operation"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(emptypeNewData);
          }}
        />
        <div className="p-3 space-y-1 border-l-2 border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Business Operation
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasBusinessOperation ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasBusinessOperation}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5"></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={emptypeNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5"></div>
        </div>
      </div>
    </div>
  );
};

export default BusinessOperationForm;
